































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Popup } from '@questelservices/common-vue';
import { Prop } from 'vue-property-decorator';
import { DxPopup, DxButton, DxSelectBox, DxTextArea, DxList, DxTextBox, DxLookup } from 'devextreme-vue';
import { DxHtmlEditor, DxItem, DxToolbar } from 'devextreme-vue/html-editor';
import { DxToolbarItem } from 'devextreme-vue/popup';
import CustomStore from 'devextreme/data/custom_store';
import { QuestelServicesClient } from '@questelservices/common/dist';
import { DxValidator, DxRequiredRule, DxStringLengthRule } from 'devextreme-vue/validator';
import { TextTemplateDto } from '@/models/TextTemplateDto';
import { TextTemplateService } from '@/service/TextTemplateService';
import _ from 'lodash';
import { TextTemplateTypeEnum } from '@/models/TextTemplateTypeEnum';
import Lookup from 'devextreme/ui/lookup';
import dxHtmlEditor from 'devextreme/ui/html_editor';
import dialog from 'devextreme/ui/dialog';
import PhaseVerbEditor from '@/components/phase-types/phase-verb-editor.vue';
import * as overlay from 'devextreme/ui/overlay';

const editorStatus = {
    valid : 'valid',
    invalid : 'invalid',
    pending : 'pending'
}

const validationRule = {
    requiredError  : {
        message : 'This is required.'
    },
    existError : {
        message : 'This already exists.'
    },
    noError : {}
}

@Component({
        components: {
            DxPopup,
            DxLookup,
            DxSelectBox,
            DxButton,
            DxTextArea,
            DxList,
            DxToolbarItem,
            DxTextBox,
            DxHtmlEditor,
            DxItem,
            DxToolbar,
            DxValidator,
            DxRequiredRule,
            DxStringLengthRule,
            PhaseVerbEditor
        }
    })
export default class AutoTextDialog extends Vue {
    $refs: Vue['$refs'] & {
        savedTextTemplateRef?: Lookup;
        textAreaRef?: DxHtmlEditor;
        saveAsComponent?: any;
        textBoxComponent?: any;
    } = {};

    @Prop()
    showDialog!: boolean;

    @Prop()
    availableAutoText! : Array<string>;

    get showingDialog() : boolean {
        return this.showDialog;
    }

    set showingDialog(value) {
      this.$emit("hidingDialog");
    }

    private get availablelAutoTextUrl(): string {
        return `/api/texttemplate/available-auto-texts`;
    }

    private get allAvailableAutoText() {
        return this.availableAutoText;
    }    

    get htmlEditor() {
        return (this.$refs.textAreaRef as DxHtmlEditor).instance as dxHtmlEditor;
    }

    showPhaseVerbEditor: boolean = false;
    textTemplateService : TextTemplateService;
    selectedText: Guid = '';
    autoTextTemplate : TextTemplateDto;
    saveOrUpdate : string = "Save";

    private defaultValue(): TextTemplateDto{
        return {
            TextTemplateId : "00000000-0000-0000-0000-000000000000",
            Name: "",
            Text: "",
            Favorite: false
        }
    }

    onClickFavorite(e:any) {
        this.autoTextTemplate.Favorite = !this.autoTextTemplate.Favorite;
    }

    onEditPhaseVerb(e:any) {
        this.showPhaseVerbEditor = true
    }
    
    saveAsOption: any = this.textBoxOption();

    textBoxOption(valid: boolean = true, 
            status: string = editorStatus.valid,
            error: any = validationRule.noError) {

            
        return {
            width: '200px',
            placeholder:'Save as',
            value: this.nameValue,
            validationStatus: status,
            validationError : error,
            onValueChanged: this.onInputChanged,
            onContentReady: this.textBoxReady,
            isValid : valid,
            maxLength: 50
        }
    }

    textBoxReady(e:any) {
        if(!this.saveAsComponent) {
            this.saveAsComponent = e.component;
        }
    }

    onNew() {
         this.saveOrUpdate = "Save";
        this.autoTextTemplate = this.defaultValue();
        this.selectedText = '';
        this.nameValue = '';
        this.saveAsOption = this.textBoxOption(false,editorStatus.invalid, validationRule.requiredError);
    }

    resetTextAreaValidation() {
        this.htmlEditor.option('validationStatus', 'valid');
        this.htmlEditor.option('validationError', undefined);
        this.htmlEditor.option('isValid', true);
        this.htmlEditor.setSelection(0, 0);
        this.htmlEditor.getQuillInstance().selection.setRange({index: 0, length: 0})
    }

    nameValue: string = '';
    saveAsComponent: any;
    onInputChanged(e:any ){
        this.nameValue = e.value;

        if(e.value){
            this.saveAsOption = this.textBoxOption();
        }
        else{
             this.saveAsOption = this.textBoxOption(false,editorStatus.invalid, validationRule.requiredError);
        }
    }

    onAvailableAutoTextChanged(e: any) {
        if (e.addedItems != null && e.addedItems.length > 0) {
            let index = this.htmlEditor.getQuillInstance().selection.savedRange.index;

            this.htmlEditor.insertText(index, e.addedItems[0], {});
            let newLength = index + e.addedItems[0].length;

            this.htmlEditor.setSelection(newLength, 0);
            e.component.instance().unselectAll();
        }
    }

    onSelectionChanged(e:any) {
        if(e.selectedItem) {
            this.autoTextTemplate.Text = e.selectedItem.Text;
            this.autoTextTemplate.Name = e.selectedItem.Name;
            this.nameValue = e.selectedItem.Name;
            this.autoTextTemplate.Favorite = e.selectedItem.Favorite;
            this.autoTextTemplate.TextTemplateId = e.selectedItem.TextTemplateId;
            this.saveOrUpdate = "Update";
            this.saveAsOption =this.textBoxOption(true, editorStatus.valid, validationRule.noError);
            this.saveAsOption.value = e.selectedItem.Name;

            this.htmlEditor.option("value", e.selectedItem.Text);
            let length = this.htmlEditor.getLength();
            this.htmlEditor.getQuillInstance().selection.setRange({ index: length, length: 0 });
        }

        if(!this.selectedText) {
            this.onNew();
        }

    }

    textTemplateStore: CustomStore;
    
    templateStore() {
        return new CustomStore({
            loadMode: 'raw',
            load: (options): Promise<any> => {
            return this.textTemplateService.getTextTemplate(TextTemplateTypeEnum.AutoText)
                .then((results : any) => {
                    return results;
                }
                
                )
                .catch(err=> []);
            }
        });
    }

     constructor() {
        super();      
        this.textTemplateService = new TextTemplateService();
        this.autoTextTemplate = this.defaultValue();
        this.saveAsOption = this.textBoxOption();
        this.textTemplateStore = this.templateStore();
        overlay.baseZIndex(2000);
     }

    clearAll() {
        this.selectedText = '';
        this.autoTextTemplate = this.defaultValue();
        this.nameValue = '';
        this.htmlEditor.reset();
    }

    onHidden(e:any) {
        this.clearAll();
        this.saveAsOption = this.textBoxOption();
        this.resetTextAreaValidation();
    }

    onShowing(e:any) {
        this.textTemplateStore = this.templateStore();
    }

    async forSave(evnt: any) {
        this.saveAutoText(false);
    }

    async forNew(evnt: any) {
        this.saveAutoText(true);
    }

    async saveAutoText(isForNew: boolean) {
        var isValid = true;
        if(!this.nameValue && !this.autoTextTemplate.Name){
            this.saveAsOption = this.textBoxOption(false,editorStatus.invalid, validationRule.requiredError);
            isValid = false;
        }
        if(!this.autoTextTemplate.Text) {
            isValid = false;
        }

        if (this.htmlEditor.option('isValid') === false) {
          isValid = false;
        }

        if(isValid) {
            let result = await dialog.confirm("Are you sure?", "Confirm Changes");
            if(result) {
                this.autoTextTemplate.TextTemplateTypeId = TextTemplateTypeEnum.AutoText;
                let payload = _.clone(this.autoTextTemplate);
                if(isForNew) {
                    payload.TextTemplateId = this.defaultValue().TextTemplateId;
                }

                this.saveAsOption = this.textBoxOption(true,editorStatus.pending);
                if(this.nameValue !== payload.Name || isForNew) {
                    payload.Name = this.nameValue;

                    this.textTemplateService.checkIfExists(payload.Name, payload.TextTemplateTypeId)
                        .then(result => {
                            if (result.Data === true) {
                                this.saveAsOption = this.textBoxOption(false, editorStatus.invalid, validationRule.existError);
                            } else {
                                this.toSave(payload);
                            }
                        })
                        .catch(reason => {
                            dialog.alert('An error occurred saving the auto text. Please try again.', 'Error');
                        });
                }
                else {
                    this.toSave(payload);
                }
            }
        }

       
    }

    toSave(payload: any) {
        if(payload.TextTemplateId === this.defaultValue().TextTemplateId){
            this.textTemplateService.insertTextTemplate(payload)
            .then(result => {
                this.showingDialog = false;
            })
            .catch(error => {

            }); 
        }
        else {
            this.textTemplateService.updateTextTemplate(payload)
            .then(result => {
                this.showingDialog = false;
            })
            .catch(error => {

            });
        }
    }

    hidingDialog() {
        this.showingDialog = false;
    }

}
